<template>
<v-window vertical touchless v-model="step">
  <v-window-item :value="0">
    <v-card flat >
      <v-alert v-if='errorMessage' :value='true' type='error' class='ma-2' outline outlined >
        {{errorMessage}}
      </v-alert>
      <v-alert v-if='statementClients.length === 0' :value='true' type='warning' class='ma-2' outline outlined >
        Warning: could not find any contacts to send this statement to
      </v-alert>
      <v-toolbar v-if='statement' dense flat >
        <v-icon class='mr-2'>post_add</v-icon>
        {{statement.title}}
        <v-spacer></v-spacer>
        <div class='hidden-xs-only' >
        <strong class='mr-2' >Closing balance:</strong> {{ formatCurrency($store.getters.settings.currency, statement.closing_balance) }}
        </div>
      </v-toolbar>
      <v-divider></v-divider>
      <send-template
        v-if='statement'
        template='STATEMENT'
        template-context='Statement'
        title= 'Who would you like to send this statement to?'
        :initial-page='1'
        :clients='statementClients'
        :context='statement'
        :send-to-me='true'
        :with-send='false'
        :touch='toucher'
        @sender='setSender'
        @recipients='setRecipients' >
      </send-template>
      <div v-else >Unable to provide sendiing options. Please try again</div>
      <v-card-actions >
        <v-spacer></v-spacer>
        <v-btn
          :disabled='!canSend'
          :loading='sending'
          @click='send' color='primary' >Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-window-item>
  <v-window-item :value="1" >

      <v-card flat style='max-width:500px;margin-left:auto;margin-right:auto;' class='text-xs-center' >
        <v-icon dark size='76' color='green' class='mt-4' >
          check_circle
        </v-icon>
        <h3 class='subheading text-xs-center mb-4' >
          Statement sent
        </h3>
        <div class='overline text-xs-left ml-4'>Messages:</div>
        <batch-id-list v-if='batchId' :batch-id='batchId' class='pb-4' >
        </batch-id-list>
      </v-card>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click='$emit("close")' flat text >Done</v-btn>
      </v-card-actions>

  </v-window-item>
</v-window>
</template>
<script>
import SendTemplate from '@/components/unibox/SendTemplate'
import BatchIdList from '@/components/communications/BatchIdList'

export default {
  name: 'SendStatement',
  components: {SendTemplate, BatchIdList},
  props: {
    value: { type: Object, default: () => { return {} } },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      step: 0,
      statement: {},
      sendStatementTo: [],
      toucher: null,
      sender: null,
      batchId: 123,
      sending: false,
      errorMessage: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.statement = this.value }
        this.reset()
      }
    },
    touch () {
      this.toucher++
      this.reset()
    }
  },
  computed: {
    me () {
      return this.$store.getters.me
    },
    canSend () {
      return (this.sendStatementTo && this.sendStatementTo.length > 0)
    },
    statementClients () {
      if (this.statement && this.statement.relationship_id) {
        let relationship = this.getRelationById(this.statement.relationship_id)
        if (relationship) {
          return [relationship]
        }
      }
      return []
    }
  },
  methods: {
    reset () {
      this.step = 0
    },
    send () {
      let params = {
        'sender': this.sender,
        'template': 'STATEMENT',
        'recipients': this.sendStatementTo
      }
      this.sending = true
      this.errorMessage = false
      this.$invoiceguru.performAction('statements', 'send', this.statement.id, params)
        .then((response) => {
          this.batchId = response.data.batch_id
          this.sending = false
          this.step = 1
        })
        .catch((err) => {
          console.err(err)
          this.errorMessage = 'An unexpected error occurred trying to send this statement. If this problem persists, please contact support@appointmentguru.co'
          this.sending = false
        })
    },
    setSender (sender) {
      this.sender = sender
    },
    setRecipients (recipients) {
      this.sendStatementTo = recipients
    }
  }
}
</script>



// WEBPACK FOOTER //
// SendStatement.vue?03f19f46